import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { MobileArticle } from '@wdx/portal/api-models';

export enum ListingType {
    Recommended = 'recommended',
    Distributed = 'distributed',
}

export const ArticlesActions = createActionGroup({
    source: 'Articles',
    events: {
        'Get Recommended Articles': emptyProps(),
        'Get Recommended Articles Success': props<{
            articles: MobileArticle[];
        }>(),
        'Get Recommended Articles Failure': props<{
            error: any;
        }>(),

        'Get Distributed Articles': emptyProps(),
        'Get Distributed Articles Success': props<{
            articles: MobileArticle[];
        }>(),
        'Get Distributed Articles Failure': props<{
            error: any;
        }>(),

        'Get Article': props<{ articleId: string }>(),
        'Get Article Success': props<{
            articleId: string;
            article: MobileArticle;
        }>(),
        'Get Article Failure': props<{
            error: any;
        }>(),
    },
});
